import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

// text,email,tel,textarea,password,
@Component({
	selector: 'textbox',
	template: `
		<div [formGroup]="form">
			<input [disabled]="disabled" *ngIf="!field.multiline" [attr.type]="field.type" class="form-control" [id]="field.name" [name]="field.name" [formControlName]="field.name" />
			<textarea
				[disabled]="disabled"
				*ngIf="field.multiline"
				[class.is-invalid]="isDirty && !isValid"
				[formControlName]="field.name"
				[id]="field.name"
				rows="9"
				class="form-control"
				[placeholder]="field.placeholder"
			></textarea>
		</div>
	`
})
export class TextBoxComponent {
	@Input() field: any = {};
	@Input() form: UntypedFormGroup;
	@Input() disabled: boolean;
	get isValid() {
		return this.form.controls[this.field.name]?.valid;
	}
	get isDirty() {
		return this.form.controls[this.field.name]?.dirty;
	}

	constructor() {}
}
